import { Text } from "./Text";
import { Event } from "../events/Event";
import { PAL } from "../platform/PlatformAdapters";
export class Input extends Text {
    constructor() {
        super();
        this.confirmType = 'done';
        this.maxChars = 0;
        this._multiline = false;
        this._editable = true;
        this._width = 100;
        this._height = 20;
        this._type = "text";
        this._promptColor = "#a9a9a9";
        this.overflow = Text.SCROLL;
        this.valign = "middle";
        this.mouseEnabled = true;
    }
    get multiline() {
        return this._multiline;
    }
    set multiline(value) {
        if (this._multiline != value) {
            this._multiline = value;
            this.wordWrap = value;
            this.valign = value ? "top" : "middle";
        }
    }
    get focus() {
        return PAL.textInput.target === this;
    }
    set focus(value) {
        if (value)
            PAL.textInput.begin(this);
        else if (this === PAL.textInput.target)
            PAL.textInput.end();
    }
    get text() {
        if (PAL.textInput.target === this)
            PAL.textInput.syncText();
        return super.text;
    }
    set text(value) {
        if (value == null)
            value = "";
        else if (typeof (value) !== "string")
            value = '' + value;
        if (PAL.textInput.target === this) {
            PAL.textInput.setText(value);
            this.event(Event.CHANGE);
        }
        else {
            if (!this._multiline)
                value = value.replace(/\r?\n/g, '');
            super.text = value;
        }
    }
    get editable() {
        return this._editable;
    }
    set editable(value) {
        this._editable = value;
    }
    get prompt() {
        return this._prompt;
    }
    set prompt(value) {
        var _a;
        if (value == null)
            value = "";
        value = ((_a = Text.langPacks) === null || _a === void 0 ? void 0 : _a[value]) || value;
        if (this._prompt != value) {
            this._prompt = value;
            this.markChanged();
        }
    }
    get promptColor() {
        return this._promptColor;
    }
    set promptColor(value) {
        if (this._promptColor != value) {
            this._promptColor = value;
            this.markChanged();
        }
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._asPassword = value === "password";
        this._type = value;
        this.markChanged();
    }
    setSelection(startIndex, endIndex) {
        this.focus = true;
        PAL.textInput.setSelection(startIndex, endIndex);
    }
    select() {
        this.focus = true;
        PAL.textInput.setSelection(0, -1);
    }
}
Input.TYPE_TEXT = "text";
Input.TYPE_PASSWORD = "password";
Input.TYPE_EMAIL = "email";
Input.TYPE_URL = "url";
Input.TYPE_NUMBER = "number";
Input.TYPE_RANGE = "range";
Input.TYPE_DATE = "date";
Input.TYPE_MONTH = "month";
Input.TYPE_WEEK = "week";
Input.TYPE_TIME = "time";
Input.TYPE_DATE_TIME = "datetime";
Input.TYPE_DATE_TIME_LOCAL = "datetime-local";
Input.TYPE_SEARCH = "search";
